export enum DateFilterOptions {
  LAST_24_HOURS = 'LAST_24_HOURS',
  LAST_7_DAYS = 'LAST_7_DAYS',
  LAST_28_DAYS = 'LAST_28_DAYS',
  SINCE_2023 = 'SINCE_2023',
}

export interface HeldReleasesFilters {
  onHeldDateFilter: DateFilterOptions;
}
